/**
 * Copyright 2022 Design Barn Inc.
 */

import Discover from './Discover';
import Import from './Import';
// import MyAnimations from './MyAnimations';
import Preview from './Preview';
import Workflow from './Workflow';

export * from './OnBoarding';
export { Discover, Import, Preview, Workflow };
